export default "__VITE_ASSET__CeHSIGfq__"